<template>
<div>
  <div class="mask" v-show="visible">
    <div class="modal-wrapper" :class="modalClass">
      <div class="modal-content">
        <div :class="icon + ' icon'"></div>
        <div class="content">
          <div v-html="content"></div>
        </div>
      </div>
      <div class="modal-footer">
        <div v-if="!showCancel">
          <Button type="primary" @click="ok">{{okText}}</Button>
        </div>
        <div v-else>
          <Button type="primary" @click="ok" style="margin-right: 10px;">{{okText}}</Button>
          <Button @click="close">{{cancelText}}</Button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'warning',
      validator: (value) => {
        return ['success', 'error', 'warning'].indexOf(value) !== -1
      }
    },
    content: {
      type: String,
      default: '网络异常，请您稍后重试。请您点击右侧在线咨询，将此截图发给客服，由专业客服7*24小时竭诚为您服务。'
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    modalClass: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: '确认'
    },
    cancelText: {
      type: String,
      default: '取消'
    }
  },
  data () {
    return {}
  },
  methods: {
    close () {
      this.visible = false
      this.okText = ''
      this.cancelText = ''
      this.onOk = null
      if (this.onCancel) {
        this.onCancel()
        this.onCancel = null
      }
    },
    ok () {
      this.visible = false
      this.okText = ''
      this.cancelText = ''
      this.onCancel = null
      if (this.onOk) {
        this.onOk()
        this.onOk = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(55, 55, 55, .6);
  height: 100%;
  width: 100%;
  z-index: 3100;
}
.modal-wrapper {
  width: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 30px 64px 20px;
  background-color: #fff;
  text-align: center;
  border-radius: 15px;
}
.modal-content {
  .icon {
    width: 60px;
    height: 60px;
    background-image: url(../../assets/icons/icon_sprite.png);
    margin: 0 auto;
  }
  .success {
    background-position: -223px -310px;
  }
  .error {
    background-position: -223px -390px;
  }
  .confirm {
    background-position: -223px -470px;
  }
  .warning {
    background-position: -223px -550px;
  }
  .content {
    margin-top: 10px;
    color: #333;
    font-size: 16px;
  }
}
.modal-footer {
  margin-top: 26px;
}
.w750{
  width: 750px;
}
</style>
